import React from "react";
import classes from "./Chip.scss";

const LabelChip = props => {
  const { id, icon, label, onClick } = props;

  return (
    <button
      data-elm="module-filter-item"
      className={classes.chipContainer}
      onClick={onClick}
      tabIndex="-1"
    >
      <div className={classes.chipIcon}>{icon}</div>
      <div className="text-body-2 whitespace-nowrap">{label}</div>
    </button>
  );
};

export default LabelChip;
